import AutoTheme from "../../lobby/view/theme/AutoTheme.vue";
import DefaultThemeView from "../../lobby/view/theme/DefaultTheme.vue";
import HomeThemeView from "../../lobby/view/theme/HomeTheme.vue";
import DefaultThemeEditPanel from "../../lobby/view/theme/modify/DefaultThemeEditPanel.vue";


import Theme1TopicJson from "./Theme1TopicJson";
import Theme2TopicJson from "./Theme2TopicJson";
import Theme3TopicJson from "./Theme3TopicJson";

import Theme from "../model/lover/Theme";
let themeMap = {};
let themeList = [];


let theme1 = new Theme();
theme1.id = 1;
theme1.component = HomeThemeView;
theme1.name = "官方主题样式";
theme1.description = "蓝色主基调的官方主题样式。";
theme1.logoRemark = " 建议尺寸：400*120 如果没有指定封面图片，默认使用标题作为专题封面";
theme1.editComponent = null;
theme1.topicJson = Theme1TopicJson;
themeList.push(theme1);

let theme2 = new Theme();
theme2.id = 2;
theme2.component = DefaultThemeView;
theme2.name = "黑色固定菜单长度带侧边栏样式";
theme2.description = "黑色为主色调，每个菜单栏长度固定,有侧边索引栏，适合菜单为中文的专题。";
theme2.logoRemark = " 建议尺寸：1000*220 如果没有指定封面图片，默认使用标题作为专题封面";
theme2.editComponent = DefaultThemeEditPanel;
theme2.topicJson = Theme2TopicJson;
themeList.push(theme2);


let theme3 = new Theme();
theme3.id = 3;
theme3.component = AutoTheme;
theme3.name = "黑色自动菜单长度带侧边栏样式";
theme3.description = "黑色为主色调，每个菜单栏长度自适应文字宽度,有侧边索引栏，适合菜单为英文的专题。";
theme3.logoRemark = " 建议尺寸：1000*220 如果没有指定封面图片，默认使用标题作为专题封面";
theme3.editComponent = DefaultThemeEditPanel;
theme3.topicJson = Theme3TopicJson;
themeList.push(theme3);



for (let i = 0; i < themeList.length; i++) {
	let s = themeList[i];
	themeMap[s.id] = s;
}

export {themeMap, themeList}


// WEBPACK FOOTER //
// ./src/common/store/Themes.js